import { render } from "./ProductFeedbackDetails.vue?vue&type=template&id=45d7e580"
import script from "./ProductFeedbackDetails.vue?vue&type=script&lang=js"
export * from "./ProductFeedbackDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__